import styled from 'styled-components';
import { Label } from 'common/baseComponents'
import { SIZE, LAYERS } from 'common/sizes';

import { LABEL, LIST } from 'common/base';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

interface IStyleProps {
    verticalMargin?: number;
    selectedTab?: string;
    hasMargin?: boolean;
    backgroundColor?: string;
}

export const Root = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    box-sizing: border-box;
`;

export const MainContainer = styled.div`
    margin: 10px 22px;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: ${(props: IStyleProps) => (props.hasMargin ? `#FFFFFF` : `auto`)};
    position: relative;
    border-radius: ${(props: IStyleProps) => (props.hasMargin ? `5px` : `auto`)};
    box-shadow: ${(props: IStyleProps) => (props.hasMargin ? `-2px 4px 15px 0 rgba(0, 0, 0, 0.15)` : `auto`)};
`;

export const WidgetContainer = styled.div`
    position: relative;
    width: 100%;
    margin:  0px 0px ${(props: IStyleProps) => (props.verticalMargin ?? 0)}px 0px;
    background-color: ${(props: IStyleProps) => (props.backgroundColor ?? `#FFFFFF`)};
    margin:  0px 0px ${(props: IStyleProps) => (props.verticalMargin ?? 0)}px 0px;
    border-radius: ${(props: IStyleProps) => (props.hasMargin ? `5px` : `auto`)};
    box-shadow: ${(props: IStyleProps) => (props.hasMargin ? `-2px 4px 15px 0 rgba(0, 0, 0, 0.15)` : `auto`)};
`;

export const LeftText = styled.div`
    position: absolute;
    left: 25px;
    top: 20px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #a5a5a5;
`;

export const SelectProviders = styled.div`
    width: 158px;
    height: 36px;
    margin: 6px 0px 11px 24px;
`;

export const ExportCodeContainer = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    border-radius: 32px;
    &:hover {
        background-color: rgba(18, 36, 66, 0.05);
    }
`;

export const RecommendedContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Recommended = styled.div`
  font-family: Rubik;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`;

interface IStyleProps {
    rotationValue?: string;
}

  
export const Icon = styled.div`
  margin-left: 8px;
  transform: ${(props: IStyleProps) => props.rotationValue ? props.rotationValue : '-100vw'};
`;